import React from "react";
import { api } from "../api/api";
import { getToken, setToken } from "../api/api";

const AuthCtx = React.createContext(null);

export function useAdminAuth() {
  return React.useContext(AuthCtx);
}

export function AdminAuthProvider({ children }) {
  const [token, setTokenState] = React.useState(getToken());
  const [admin, setAdmin] = React.useState(null);
  const [loading, setLoading] = React.useState(true);

  async function refreshMe() {
    if (!getToken()) {
      setAdmin(null);
      setLoading(false);
      return;
    }
    try {
      const data = await api.me();
      setAdmin(data.admin || null);
    } catch (e) {
      // token invalid
      setToken("");
      setTokenState("");
      setAdmin(null);
    } finally {
      setLoading(false);
    }
  }

  React.useEffect(() => {
    refreshMe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  async function login(username, password) {
    const res = await api.login(username, password);
    if (!res?.token) throw new Error("No token returned");
    setToken(res.token);
    setTokenState(res.token);
    return res.token;
  }

  function logout() {
    setToken("");
    setTokenState("");
    setAdmin(null);
  }

  const value = {
    token,
    admin,
    loading,
    login,
    logout,
    refreshMe,
    isAuthed: !!token,
  };

  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}
